<template>
  <v-app-bar
    class="ch-app-bar"
    fixed
    app
    dark
    flat
    height="60"
    extension-height="66"
    color="topBar"
  >
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.mdAndDown"
      @click="setAppDrawerLeft(!appDrawerLeft)"
    />
    <div
      v-if="$vuetify.breakpoint.mdAndDown"
      class="logo-container py-3 flex-grow-1"
    >
      <a href="/">
        <img src="@/assets/logo.png" />
      </a>
    </div>

    <v-autocomplete
      v-if="$vuetify.breakpoint.mdAndUp"
      class="search-field ml-4"
      prepend-inner-icon="fa fa-search"
      placeholder="Search FAQs"
      hide-details
      solo
      :search-input.sync="faqSearchQuery"
      :items="faqMappedItems"
      :loading="faqLoading || faqQueued"
      :no-data-text="(faqLoading || faqQueued) ? 'Loading...' : 'No results found.'"
      :hide-no-data="!faqSearchQuery"
      @input="selectFaq"
      v-model="selectedFaq"
    >

    </v-autocomplete>
    <v-spacer />
    <v-btn
      v-if="$vuetify.breakpoint.mdAndUp"
      text
      class="mr-5"
      small
      href="/"
    >Back To Shopping</v-btn>
    <v-btn
      icon
      href="/support/"
    >
      <v-icon>fa fa-phone-alt</v-icon>
    </v-btn>

    <!-- <v-badge
      color="error"
      content="2"
      overlap
      offset-y="22"
      offset-x="24"
      class="mr-5"
    >
      <v-btn
        icon
      >
        <v-icon>fa fa-bell</v-icon>
      </v-btn>
    </v-badge> -->

    <v-badge
      color="success"
      :content="(cart && cart.product_count) || ''"
      overlap
      offset-y="22"
      offset-x="24"
      :value="cart && cart.product_count"
    >
      <v-btn
        icon
        href="/cart.php?mode=checkout&step=info"
      >
        <v-icon>fa fa-shopping-cart</v-icon>
      </v-btn>
    </v-badge>

    <!-- <v-avatar color="primary" size="36">
      <span class="white--text headline">OG</span>
    </v-avatar> -->
    <slot
      v-if="$slots.extension"
      name="extension"
      slot="extension"
    />
    <template
      v-else
      slot="extension"
    >
      <h1>
        <span
          v-if="!noBreadcrumb"
        >
          <router-link :to="{ name: 'Home' }">Account</router-link>
          <span class="mx-4">/</span>
          <template
            v-for="(breadcrumb, bcIndex) in breadcrumbs"
          >
            <router-link
              :to="breadcrumb.to"
              :key="bcIndex"
            >{{ breadcrumb.name }}</router-link>
            <span
              class="mx-4"
              :key="bcIndex + 'slash'"
            >/</span>
          </template>
        </span>{{ header || '' }}
      </h1>
      <v-spacer />
    </template>
  </v-app-bar>
</template>

<style lang="scss">
.ch-app-bar {
  .v-app-bar__nav-icon {
    margin-left: 0 !important;
  }
  .v-toolbar__content {
    padding-left: 0;
  }
  .search-field {
    .v-input__icon--prepend-inner {
      i {
        font-size: 16px;
        padding-top: 2px;
        padding-right: 3px;
      }
    }
  }
  .logo-container {
    height: 60px;
    width: 260px;
    text-align: center;
    img {
      height: 100%;
    }
  }
  .v-toolbar__extension {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.6);
    border-bottom: 1px $lightBorder solid;
    a {
      color: inherit;
      text-decoration: underline;
    }
    h1 {
      font-size: 1.17em;
      font-weight: bold;
      line-height: 1.5; 
    }
  }
}
</style>

<script>
import { mapState, mapMutations } from 'vuex'
import { Faq, XConfig } from '@/models'
// import axios from 'axios'

export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    noBreadcrumb: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      faqSearchQuery: null,
      faqItems: [],
      faqLoading: false,
      faqQueued: false,
      selectedFaq: null,
      preventSearch: false
    }
  },
  computed: {
    ...mapState(['appDrawerLeft', 'cart']),
    faqMappedItems () {
      return this.faqItems.map(f => ({ text: f.question, value: f.faqid }))
    },
    phoneUrl () {
      const phoneConfig = XConfig.find('company_phone')
      if (phoneConfig) {
        return `tel://${phoneConfig.value.replace('Toll Free - ', '').replace(/[.\- ]/g, '')}`
      }
      return null
    }
  },
  watch: {
    faqSearchQuery () {
      this.faqQueued = true
      // If there's already a request running, don't make another one
      if (this.faqLoading) {
        return
      }
      clearTimeout(this.searchFaqTimeout)
      this.searchFaqTimeout = setTimeout(() => {
        this.faqLoading = true
        this.searchFaq()
      }, 400)
    }
  },
  methods: {
    ...mapMutations(['setAppDrawerLeft']),
    async searchFaq () {
      const faqSearchQuery = this.faqSearchQuery
      if (!faqSearchQuery) {
        this.faqItems = []
        this.faqLoading = false
        this.faqQueued = false
        return
      }
      try {
        const response = await Faq.fetchMany({
          params: {
            search: this.faqSearchQuery
          }
        })

        this.faqItems = (response.entities && response.entities.faq) || []
        // If the searchQuery has changed during this request, run again
        if (faqSearchQuery !== this.faqSearchQuery) {
          this.searchFaq()
        } else {
          this.faqLoading = false
          this.faqQueued = false
        }
      } catch (e) {
        this.faqLoading = false
        this.faqQueued = false
        // Set UI state for error
        console.error(e)
        throw e
      }
    },
    async selectFaq (faqId) {
      this.$router.push({ name: 'Faq', params: { faqId } })
      await this.$nextTick()
      this.selectedFaq = null
    }
  }
}
</script>
